import { render, staticRenderFns } from "./modules-manager.vue?vue&type=template&id=28408981&scoped=true&"
import script from "./modules-manager.vue?vue&type=script&lang=js&"
export * from "./modules-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28408981",
  null
  
)

export default component.exports